<fs-base-header></fs-base-header>
<div class="content">
  <mat-card appearance="outlined">
    @if (!invalidProfileType) {
      <mat-card-title>
        {{'HOME.WELCOME_' + (profile.username == null ? 'NO_USERNAME' : 'USER')| translate:{username: profile.username} }}
      </mat-card-title>
      @if (CUSTOMIZATION.allowOrganisationCreation) {
        <mat-card-subtitle>
          {{'HOME.WELCOME' | translate:{appName: CUSTOMIZATION.appName} }}
        </mat-card-subtitle>
      }
      @if (organisations != null) {
        @if (organisations.length > 0) {
          <mat-card-content>

            @if (profile.profile.status !== 'ACTIVE') {
              <p class="warning">
                <span>{{'HOME.PROFILE_NOT_ACTIVE' | translate}}</span>
                <button mat-raised-button (click)="completeProfile()">{{'HOME.COMPLETE_PROFILE' | translate}}</button>
              </p>
            }

            @if(organisations.length > 4) {
              <mat-form-field appearance="outline">
                <mat-label>{{'HOME.FILTER_ORGANISATIONS' | translate}}</mat-label>
                <mat-icon matPrefix>search</mat-icon>
                <input matInput [formControl]="filter" type="text"/>
              </mat-form-field>
            }
            <mat-nav-list>
              @for (status of STATUSES; track status) {
                @if (organisationsByStatus[status]?.length > 0) {
                  <h3>{{'HOME.ORGANISATIONS.' + status | translate}}</h3>
                  @for (organisation of organisationsByStatus[status]; track $index) {
                    <mat-list-item  [ngClass]="organisation.status"
                                    [disableRipple]="organisation.status === STATUS.BLOCKED"
                                    [matTooltip]="organisation.status === STATUS.PENDING ? ('HOME.PENDING' | translate) : null"
                                    (click)="selectOrganisation(organisation)">
                      <img alt="organisation logo" matListItemAvatar fsAvatar [round]="false" [organisationId]="organisation.id" [size]="40"/>
                      <h3 matListItemLine>{{organisation.name}}</h3>
                      @if (showDetails) {
                        <p matListItemLine>
                          {{'HOME.ORGANISATIONS.CREATION_DATE' | translate:{date: (organisation.creationDate | date)} }}
                          | {{organisation.alias}}
                        </p>
                      }
                      @if (organisation.status !== STATUS.BLOCKED) {
                        <mat-icon matListItemIcon>chevron_right</mat-icon>
                      }
                    </mat-list-item>
                  }
                }
              }
            </mat-nav-list>
          </mat-card-content>
          <mat-card-actions class="layout-row between-center">
            <button mat-button (click)="showDetails = !showDetails">
              <mat-icon>info_outline</mat-icon>
              <span>{{'HOME.BUTTONS.' + (showDetails ? 'HIDE_DETAILS' : 'SHOW_DETAILS') | translate}}</span>
            </button>
            <button mat-flat-button color="primary" [routerLink]="['/create']">
              {{'HOME.BUTTONS.ADD_ORGANISATION' | translate}}
            </button>
          </mat-card-actions>
        } @else {
          @if (CUSTOMIZATION.allowOrganisationCreation) {
            <mat-card-content class="no-organisation-content">
              <p>{{'HOME.ORGANISATIONS.NONE' | translate:{appName: CUSTOMIZATION.appName} }}</p>
              <button mat-flat-button color="primary" id="fs-create-organisation" [routerLink]="['/create']">
                {{'HOME.BUTTONS.CREATE_ORGANISATION' | translate}}
              </button>
              <span class="invited-help" [matTooltip]="'HOME.INVITE_LINK' | translate">
                {{'HOME.INVITED' | translate}}
              </span>
            </mat-card-content>
          } @else {
            <mat-card-content class="no-organisation-content">
              <p><strong>{{'HOME.INVITED' | translate}}</strong></p>
              <p>{{'HOME.INVITE_LINK' | translate}}</p>
            </mat-card-content>
          }
        }
      }
      @if (invites?.length) {
        <div class="invites">
          <h3>{{'HOME.INVITES' | translate}}</h3>
          @for (invite of invites; track invite.id) {
            <div class="invite">
              @if ((invite.reference | referenceToName | async); as name) {
                <div class="orgaName">{{name}}</div>
                <div class="invite-actions">
                  <button mat-mini-fab color="primary" (click)="acceptInvite(invite, name)"><mat-icon>check</mat-icon></button>
                  <button mat-icon-button (click)="rejectInvite(invite)"><mat-icon>close</mat-icon></button>
                </div>
              }
            </div>
          }
        </div>
      }
    } @else {
      <mat-card-content>
        <div class="invalid-profile-type">
          <mat-icon class="mat-icon-2x">mood_bad</mat-icon>
          <p [innerHtml]="'HOME.INVALID_PROFILE_TYPE' | translate:{appName: CUSTOMIZATION.appName} "></p>
          <button mat-flat-button color="warn" (click)="logout()">
            {{'COMMON.BUTTONS.LOGOUT' | translate}}
          </button>
        </div>
      </mat-card-content>
    }
  </mat-card>
</div>
